import { Fragment } from 'react';
import AlertBlock from './components/UI/AlertBlock/AlertBlock';
import AppRoutes from './components/routes/AppRoutes';
import './css/Main.css';
import 'react-datepicker/dist/react-datepicker.css';

const App = () => {
  return (
    <Fragment>
      <AlertBlock />
      <AppRoutes />
    </Fragment>
  );
};

export default App;
